<script>
  export default {
    name: "WidgetCustomCode",
    props: {
      code: {
        type: String,
        required: true
      }
    }
  }
</script>

<template>
  <div class="widget-wrapper">
    <div v-html="code" />
  </div>
</template>

<style scoped>
  @media screen and (min-width: 1024px) {
    .widget-wrapper {
      padding: 0 30px;
    }
  }
</style>
